// removed by extract-text-webpack-plugin
module.exports = {"overlay-drop-shadow":"overlay-drop-shadow-c58d9d","sapcnqr-overlay":"sapcnqr-overlay-662c86","sapcnqr-overlay__content":"sapcnqr-overlay__content-231ec4"};